let host = process.env.API_HOST || process.env.REACT_APP_API_HOST || "/";

const config = { host };
export { config };